<template>
  <DpplNewButton
    :href="microsoftUrl"
    type="button"
    variant="outlined"
    data-testid="login-microsoft-button"
    class="w-100 text-button-2"
    :height="40"
    :disabled="loading"
  >
    <img
      src="@/assets/icon-microsoft.svg"
      class="mr-1"
      width="24px"
      height="24px"
      alt="Sign in with Microsoft"
    >
    Sign in with Microsoft
  </DpplNewButton>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  microsoftUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
